import './banner.css';

const LARGE_NAME_FONTS = [
  "Playfair Display, serif",
  "Cinzel Decorative, serif",
];

const NoPhotoBanner = ({ values }) => {
   const isLargeNameFont = LARGE_NAME_FONTS.includes(
  values?.nameFontStyle
); 

  const noPhotoGroomNameDisplay = () => {
    return (
      <h3
        className={`t1-banner-name ${
        isLargeNameFont ? "t1-banner-name--compact" : ""
      }`}
        style={{ fontFamily: values.nameFontStyle }}
      >
        {values.groomName || "Groom"}
      </h3>
    );
  };

  const noPhotoBrideNameDisplay = () => {
    return (
      <h3
            className={`t1-banner-name ${
        isLargeNameFont ? "t1-banner-name--compact" : ""
      }`}
        style={{ fontFamily: values.nameFontStyle }}
      >
         {values.brideName || "Bride"}
      </h3>
    );
  };

  return (
    <>
      <picture>

        <source
          media="(min-width:768px)"
          srcSet={`
            https://res.cloudinary.com/depixc8dq/image/upload/w_1080/v1783947737/aamantran%20assets/Theme1deskbg_wi33cl.jpg 1080w,
            https://res.cloudinary.com/depixc8dq/image/upload/w_1920/v1783947737/aamantran%20assets/Theme1deskbg_wi33cl.jpg 1920w
          `}
          sizes="100vw"
        />

        <img
          src="https://res.cloudinary.com/depixc8dq/image/upload/v1783859458/aamantran%20assets/Theme1mobilebg_uia4ci.jpg"
          loading="lazy"
          srcSet={`
            https://res.cloudinary.com/depixc8dq/image/upload/w_320/v1783859458/aamantran%20assets/Theme1mobilebg_uia4ci.jpg 320w,
            https://res.cloudinary.com/depixc8dq/image/upload/w_640/v1783859458/aamantran%20assets/Theme1mobilebg_uia4ci.jpg 640w,
            https://res.cloudinary.com/depixc8dq/image/upload/w_1080/v1783859458/aamantran%20assets/Theme1mobilebg_uia4ci.jpg 1080w
          `}
          sizes="100vw"
          alt="cover background"
        />

      </picture>

      <div className="t1-banner-card">

        <img
          src="/theme1coverflower.png"
          className="card-flower card-flower-top"
          alt="cover-flower"
        />

        <div className="t1-banner-details">

          <span className="t1-banner-content">
            We are honored to welcome you to the wedding ceremony of
          </span>

          <div className="t1-banner-name-wrapper">

            {values.displayOrder === "groomFirst" ? (
              <>
                {noPhotoGroomNameDisplay()}

                <span
                      className={`t1-banner-and ${
        isLargeNameFont ? "t1-banner-and--compact" : ""
      }`}
                  style={{ fontFamily: values.nameFontStyle }}
                >
                  &
                </span>

                {noPhotoBrideNameDisplay()}
              </>
            ) : (
              <>
                {noPhotoBrideNameDisplay()}

                <span
                      className={`t1-banner-and ${
        isLargeNameFont ? "t1-banner-and--compact" : ""
      }`}
                  style={{ fontFamily: values.nameFontStyle }}
                >
                  &
                </span>

                {noPhotoGroomNameDisplay()}
              </>
            )}

          </div>

          <div className="t1-banner-hashtag">
        {values.hashtag ? `#${values.hashtag}` : ""}
          </div>

        </div>

        <img
          src="/theme1coverflower.png"
          alt=""
          className="card-flower card-flower-bottom"
        />

      </div>
    </>
  );
};

export default NoPhotoBanner;